import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import type { MoneyFragment } from '@/graphql/saleor/api';
import type { Maybe } from '@/lib/types';
import { useConfigProvider } from '@/providers/ConfigProvider';

interface YourAssetWidgetProps {
  language: string;
  price: Maybe<MoneyFragment>;
  sku: string;
  variantCTA?: OrderAppCtaType;
}

export default function YourAssetWidget({
  language,
  price,
  sku,
  variantCTA,
}: Readonly<YourAssetWidgetProps>) {
  const merchantPublicKey =
    process.env.NEXT_PUBLIC_YOUR_ASSET_MERCHANT_PUBLIC_KEY?.trim() ||
    'fe65beb0-dce9-4962-a94e-ca53060cf479';

  const { yourAssetPaymentMax, yourAssetPaymentMin } = useConfigProvider();

  if (
    !price ||
    variantCTA !== 'ORDER' ||
    price.amount > (yourAssetPaymentMax ?? 0) ||
    price.amount < (yourAssetPaymentMin ?? 0)
  )
    return null;

  return (
    <ya-finance-now
      financing-page
      full-width
      language={language}
      merchantid={merchantPublicKey}
      price={price.amount}
      sku={sku}
      theme='p-white'
    />
  );
}
